"use client"
import React, { useState, useRef, useEffect } from "react";

import "@/components/shared/RichTextBlock.css";

export function useIsOverflowing(lineClamp = 4) {
  const ref = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // temporarily remove clamp to measure full height
    const prevLineClamp = el.style.webkitLineClamp;
    el.style.webkitLineClamp = "unset";
    el.style.display = "-webkit-box"; // ensure consistent layout
    el.style.webkitBoxOrient = "vertical";
    const fullHeight = el.scrollHeight;

    // restore clamp to measure visible height
    el.style.webkitLineClamp = lineClamp;
    const visibleHeight = el.clientHeight;

    setIsOverflowing(fullHeight > visibleHeight + 1);

    // cleanup
    el.style.webkitLineClamp = prevLineClamp;
  }, [lineClamp]);

  return [ref, isOverflowing];
}

const RichTextBlock = ({ richText, collapsable = false, as = "p" }) => {
  const [expanded, setExpanded] = useState(!collapsable);
  const [ref, isOverflowing] = useIsOverflowing(3);

  return (
    <>
      {richText && richText.content && (
        <>
          <div
            ref={ref}
            className={`rich-text-block ${collapsable ? "collapsable" : ""} ${
              expanded ? "expanded" : "collapsed"
            }`}
          >
            {richText.format === "HTML" && (
              <>
                {as === "p" && (
                  <div dangerouslySetInnerHTML={{ __html: richText.content }} />
                )}
                {as === "span" && (
                  <span
                    dangerouslySetInnerHTML={{ __html: richText.content }}
                  />
                )}
              </>
            )}
            {richText.format === "PLAINTEXT" && (
              <>
                {as === "p" && <p>{richText.content}</p>}
                {as === "span" && <span>{richText.content}</span>}
              </>
            )}
          </div>
          {collapsable && isOverflowing && (
            <button
              className="collapse-button a"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? "Show less" : "Show more"}
            </button>
          )}
        </>
      )}
    </>
  );
};

export default RichTextBlock;
